<template>
  <div class="high_register_root">
    <div class="main-content-wrap">
      <div class="cont_box">
        <div class="header">
          <img class="logo" src="@/assets/images/footballAssociation.png">
          <img class="title" src="@/assets/images/title_picture.png">
        </div>
        <div class="main">
          <div class="header_wrap">
            <span class="btn nav_btn" @click="back">返回</span>
            <img src="@/assets/images/sign_up_title.png" alt="中国足协高端培训班报名">
          </div>
          <vue-scroll :ops="vuescrollOpt">
            <div class="form_wrap">
              <div class="form_cont">
                <el-form
                  :model="formData"
                  :rules="settingFormRules"
                  ref="mainForm"
                  label-width="90px"
                  size="medium"
                  class="form-cont"
                >
                  <el-form-item label="证件号码" prop="idNum">
                    <el-input v-model.trim="formData.idNum" placeholder="请准确填写证件号码"></el-input>
                  </el-form-item>
                  <el-form-item label="姓名" prop="username">
                    <el-input v-model.trim="formData.username" placeholder="请填写与证件一致的姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="验证码" prop="verificationCode">
                    <el-input v-model.trim="formData.verificationCode" placeholder="请输入验证码"></el-input>
                  </el-form-item>
                  <div class="code-wrap">
                    <div class="code_img_wrap">
                      <img
                        :src="verificationBase64"
                        v-show="!showLoading"
                        @load="showLoading=false"
                      >
                      <i class="el-icon-loading loading-code" v-show="showLoading"></i>
                    </div>
                    <div class="refresh-code" @click="getVerificationCode">看不清，换一张验证码</div>
                  </div>
                  <div class="btns">
                    <el-button type="primary" :loading="repeatSubmit" @click="next">验证进入报名</el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import commonFun from "@/assets/js/yioks";
import { getPhotoCode } from "@/api/common/achievement";
import { highRegister_1 } from "@/api/ab_signup/api";

const { idCard_number, uuid } = commonFun;

export default {
  name: "high-register",
  components: {
    // "v-icon": () => import("vue-awesome/components/Icon"),
    "app-footer": () => import("@/components/LayOut/Common/Footer")
  },
  created() {
    this.nonce_str = this.uuid();
    this.getVerificationCode();
  },
  data() {
    const settingFormRules = {
      username: [{ required: true, message: "请填写姓名", trigger: "blur" }],
      idNum: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (idCard_number(value)) {
              callback();
            } else {
              callback(new Error("请输入正确的证件号"));
            }
          },
          trigger: "blur"
        }
      ],
      verificationCode: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (val) {
              if (!this.verification.verify) {
                callback();
              } else {
                callback(new Error(this.verification.msg));
                this.verification.verify = false;
                this.verification.msg = '';
              }
            } else {
              callback(new Error("请输入验证码"));
            }
          },
          trigger: "blur"
        }
      ]
    };
    return {
      vuescrollOpt: createScrollOpt(),
      formData: {
        username: "",
        idNum: "",
        verificationCode: ""
      },
      verificationBase64: "",
      showLoading: true,
      repeatSubmit: false,
      settingFormRules,
      verification: {
        verify: false,
        msg: ""
      },
    };
  },
  methods: {
    getVerificationCode() {
      this.showLoading = true;
      getPhotoCode({
        nonce_str: this.nonce_str,
        timestamp: Date.now()
      })
        .then(({ data: { result, status, msg } }) => {
          if (Number(status) === 0) {
            this.verificationBase64 = result.verificationBase64;
          } else {
            this.$message.error(msg);
          }
          this.showLoading = false;
        })
        .catch(err => {
          this.showLoading = false;
          console.log(err);
        });
    },
    next() {
      if (this.repeatSubmit) return;
      this.repeatSubmit = true;
      this.$refs.mainForm.validate(valid => {
        if (valid) {
          highRegister_1({
            nonce_str: this.nonce_str,
            verification_code: this.formData.verificationCode,
            id_number: this.formData.idNum,
            name: this.formData.username,
            enroll_uuid: this.$route.query.uuid
          }).then(({ data: {msg, status, result} }) => {
            this.repeatSubmit = false;
            if(Number(status) === 0) {
              switch (Number(result.is_newUser)) {
                case 0:
                  // 进入第二步
                  this.$router.push({
                    path: '/hign_register_new',
                    query: {id_number: this.formData.idNum, name: this.formData.username, puuid: result.puuid}
                  });
                  break;
                case 1:
                  this.$router.push({
                    path: '/login',
                    query: {tmpUserName: this.formData.idNum, tmpUserType: 'registration'}
                  });
                  break;
                default:
                  break;
              }
            } else if (Number(status) === 510) {
              this.verification.verify = true;
              this.verification.msg = msg;
              this.$refs.mainForm.validateField("verificationCode");
              this.getVerificationCode();
            } else if(Number(status) === 457) {
              this.verification.verify = true;
              this.verification.msg = msg;
              this.$refs.mainForm.validateField("verificationCode");
              this.getVerificationCode();
            } else {
              this.getVerificationCode();
              this.$message.error(msg);
            }
          });
        } else {
          this.repeatSubmit = false;
          this.$message.error("请检查所填写的内容是否正确");
        }
      });
    },
    uuid() {
      let s = [];
      const hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "";
      return s.join("");
    },
    back(){
      this.$router.go(-1);
    },
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'

.high_register_root
  display block
  width 100%
  height 100%
  .main-content-wrap
    height calc(100% - 60px)
    display flex
    justify-content center
    user-select none
    color $color_white
    font-size $font_size_medium
    line-height inherit
    .cont_box
      display block
      width 890px
      padding-top 95px
      .header
        display flex
        justify-content center
        align-items center
        margin-bottom 20px
        .logo
          width 120px
          height 120px
          margin-right 15px
      .main
        display block
        height 608px
        padding 20px 30px 10px
        background-color $block_bg_color_base
        box-shadow 2px 2px 2px rgba(0, 0, 0, 0.2)
        position relative
        color $color_white
        .header_wrap
          display flex
          align-items center
          justify-content flex-start
          margin 0 30px 15px
          padding-bottom 10px
          border-bottom 1px solid #ccc
          img
            padding-left 120px
        .btn
          display inline-block
          line-height 1
          white-space nowrap
          cursor pointer
          text-align center
          outline none
          border-radius 5px
          padding 8px 16px
          background-color $color_suc
        .form_wrap
          display block
          padding 0 100px
          .title
            display block
            text-align center
            font-size 32px
            letter-spacing 0.05em
            // font-weight bolder
            margin-bottom 20px
          .form_cont
            display block
            margin 0 100px
            padding-top 20px
            .el-form-item
              margin-bottom 50px
            .code-wrap
              position relative
              display block
              height 40px
              margin 0 20px 30px
              display flex
              // justify-content flex-end
              // padding-left 30px
              .code_img_wrap
                display flex
                align-items center
                justify-content center
                width 150px
                text-align center
                background-color $color_white
                img
                  display block
                  width 100%
                  height 100%
                .loading-code
                  font-size 30px
                  color $color_black
              .refresh-code
                flex 1
                margin-left 10px
                padding 0 10px
                display flex
                justify-content center
                align-items center
                color $color_white
                background-color $color_suc
                cursor pointer
            .btns
              display block
              text-align center
            .el-form-item__label
              color $color_white
              font-size 16px
            .el-radio
              color $color_white
            .el-input__inner, .el-textarea__inner
              // border-radius 0
            .el-input.is-disabled .el-input__icon
              color #666
            .el-form-item.is-required .el-form-item__label:before
              color inherit
            .el-input.is-disabled .el-input__inner
              input-disabled()
</style>
